import { CartLinesUpdateEvent } from '@shopify/events';

if (!globalThis.__xbFabricCartBridgeInstalled) {
  globalThis.__xbFabricCartBridgeInstalled = true;

  let waitingForXbAdd = false;
  let waitingTimeout;

  function markXbInteraction(event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('.xbfsbu-block')) return;

    waitingForXbAdd = true;
    clearTimeout(waitingTimeout);

    waitingTimeout = setTimeout(() => {
      waitingForXbAdd = false;
    }, 5000);
  }

  function isCartAdd(url, method = 'GET') {
    if (String(method).toUpperCase() !== 'POST') return false;

    try {
      const pathname = new URL(String(url), window.location.origin).pathname;
      return /\/cart\/add(?:\.js)?$/.test(pathname);
    } catch {
      return false;
    }
  }

  document.addEventListener('click', markXbInteraction, true);

  const originalFetch = window.fetch.bind(window);

  async function refreshFabricCart() {
    if (!waitingForXbAdd) return;

    waitingForXbAdd = false;
    clearTimeout(waitingTimeout);

    try {
      const root = globalThis.Shopify?.routes?.root || '/';
      const response = await originalFetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });

      if (!response.ok) return;

      const ajaxCart = await response.json();
      const deferred = CartLinesUpdateEvent.createPromise();

      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'update',
          context: 'cart',
          lines: ajaxCart.items.map((item) => ({
            id: item.key,
            quantity: item.quantity
          })),
          promise: deferred.promise
        })
      );

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          itemCount: ajaxCart.item_count,
          source: 'xb-free-shipping-upsell',
          didError: false
        }
      });
    } catch (error) {
      console.warn('[XB/Fabric] Actualisation du panier impossible', error);
    }
  }

  window.fetch = async function (input, init = {}) {
    const response = await originalFetch(input, init);

    const url = input instanceof Request ? input.url : input;
    const method =
      init.method ||
      (input instanceof Request ? input.method : 'GET');

    if (
      waitingForXbAdd &&
      response.ok &&
      isCartAdd(url, method)
    ) {
      queueMicrotask(refreshFabricCart);
    }

    return response;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this.__xbFabricCartAdd =
      waitingForXbAdd && isCartAdd(url, method);

    return originalOpen.call(this, method, url, ...args);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this.__xbFabricCartAdd) {
      this.addEventListener(
        'load',
        () => {
          if (this.status >= 200 && this.status < 300) {
            refreshFabricCart();
          }
        },
        { once: true }
      );
    }

    return originalSend.apply(this, args);
  };
}